/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_OrganizeInputs */

const en_us2_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize workouts`)
};

const pt_br2_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizar treinos`)
};

const es_419_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizar entrenamientos`)
};

const pt_pt2_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizar treinos`)
};

const fr_fr2_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organiser les séances`)
};

const de_de2_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings ordnen`)
};

const it_it2_plan_build_organize = /** @type {(inputs: Plan_Build_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizza allenamenti`)
};

/**
* | output |
* | --- |
* | "Organize workouts" |
*
* @param {Plan_Build_OrganizeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize = /** @type {((inputs?: Plan_Build_OrganizeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_OrganizeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize(inputs)
	if (locale === "es-419") return es_419_plan_build_organize(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize(inputs)
	return en_us2_plan_build_organize(inputs)
});
export { plan_build_organize as "plan-build.organize" }